import { jsx as _jsx } from "react/jsx-runtime";
export const CanvaEmbed = ({ contentInfo, originalUrl }) => {
    const iframeUrl = /watch\/?/u.test(new URL(originalUrl).pathname)
        ? `https://www.canva.com/design/${contentInfo.designId}/watch?embed`
        : `https://www.canva.com/design/${contentInfo.designId}/view?embed`;
    return (_jsx("iframe", { allowFullScreen: true, loading: "lazy", src: iframeUrl, style: {
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            height: 500,
            width: '100%',
        } }));
};
//# sourceMappingURL=CanvaEmbed.js.map